import React from 'react';
import { ShieldCheck, ShieldAlert, AlertTriangle } from 'lucide-react';

export const ProphylaxisDiagram = () => (
  <div className="grid gap-3 sm:grid-cols-2" role="table" aria-label="Comparación de profilaxis neonatal">
    <div role="row" data-testid="prophylaxis-low-risk" className="rounded-lg border border-emerald-200 bg-emerald-50 p-5">
      <ShieldCheck className="mb-3 text-emerald-700" size={24} /><h3 data-testid="prophylaxis-low-title" className="text-base font-bold">Bajo riesgo</h3>
      <p data-testid="prophylaxis-low-threshold" className="mt-1 text-sm">Madre con CV &lt; 50 copias/mL</p>
      <p data-testid="prophylaxis-low-treatment" className="mt-5 border-t border-emerald-200 pt-4 text-sm font-bold">Zidovudina oral · Monoterapia</p>
      <p data-testid="prophylaxis-low-duration" className="my-2 text-xl font-extrabold">4 SEMANAS</p><p data-testid="prophylaxis-low-dosage" className="text-sm">4 mg/kg/dosis cada 12 h.</p>
    </div>
    <div role="row" data-testid="prophylaxis-high-risk" className="rounded-lg border border-amber-300 bg-amber-50 p-5">
      <ShieldAlert className="mb-3 text-amber-700" size={24} /><h3 data-testid="prophylaxis-high-title" className="text-base font-bold">Alto riesgo</h3>
      <p data-testid="prophylaxis-high-threshold" className="mt-1 text-sm">CV materna &gt; 1,000, diagnóstico intraparto o sin TAR</p>
      <p data-testid="prophylaxis-high-treatment" className="mt-5 border-t border-amber-200 pt-4 text-sm font-bold">Triple terapia combinada</p>
      <p data-testid="prophylaxis-high-duration" className="my-2 text-xl font-extrabold">6 SEMANAS</p><p data-testid="prophylaxis-high-medications" className="text-sm">Zidovudina + Lamivudina + Nevirapina/Raltegravir.</p>
    </div>
  </div>
);

const milestones = [
  ['Al nacimiento', '< 48 horas', '1ª PCR virológica', 'Infección intrauterina'],
  ['4 a 6 semanas', 'Posprofilaxis', '2ª PCR virológica', 'Posprofilaxis neonatal'],
  ['4 a 6 meses', 'Confirmación', '3ª PCR virológica', 'Confirmación virológica'],
  ['18 meses', 'Descarte definitivo', 'Serología ELISA / Rápida', 'Anticuerpos: descarte serológico definitivo'],
];

export const PCRTimeline = () => (
  <div>
    <ol className="mc-timeline mt-4">
      {milestones.map(([age, timing, test, detail], i) => (
        <li key={age} data-testid={`pcr-milestone-${i}`} className="mc-timeline-item">
          <p data-testid={`pcr-timing-${i}`} className="text-xs font-bold text-neutral-500">{String(i + 1).padStart(2, '0')} / {timing}</p>
          <h3 data-testid={`pcr-age-${i}`} className="mt-2 text-sm font-extrabold">{age}</h3><p data-testid={`pcr-test-${i}`} className="mt-2 text-sm font-bold">{test}</p>
          <p data-testid={`pcr-detail-${i}`} className="mt-1 text-xs text-neutral-600">{detail}</p>
        </li>
      ))}
    </ol>
    <p role="note" data-testid="pcr-elisa-warning" className="mt-5 flex gap-3 rounded-lg border border-red-200 bg-red-50 p-4 text-sm font-bold text-red-800">
      <AlertTriangle size={20} className="shrink-0" />¡ELISA contraindicado para diagnóstico antes de los 18 meses por persistencia de IgG materna!
    </p>
  </div>
);